import axios from "axios";
import { getToken } from "../../../Utlis/UpdateUserState";

const getFuelBrands = async () => {
  try {
    const token = getToken();

    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}admin/fuel-brands/`,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Fuel brands fetch error:", error);
    throw error;
  }
};

const getFuelBrandById = async (id) => {
  try {
    const token = getToken();

    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}admin/fuel-brands/?id=${id}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Fuel brand fetch error:", error);
    throw error;
  }
};

const createFuelBrand = async (data) => {
  try {
    const token = getToken();

    const res = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}admin/fuel-brands/`,
      data,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Fuel brand create error:", error);
    throw error;
  }
};

const updateFuelBrand = async (id, data) => {
  try {
    const token = getToken();

    const res = await axios.patch(
      `${process.env.REACT_APP_BACKEND_URL}admin/fuel-brands/?id=${id}`,
      data,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Fuel brand update error:", error);
    throw error;
  }
};

const updateFuelBrandStatus = async (id, data) => {
  try {
    const token = getToken();

    const res = await axios.patch(
      `${process.env.REACT_APP_BACKEND_URL}admin/fuel-brands/status/?id=${id}`,
      data,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Fuel brand status update error:", error);
    throw error;
  }
};

const deleteFuelBrand = async (id) => {
  try {
    const token = getToken();

    const res = await axios.delete(
      `${process.env.REACT_APP_BACKEND_URL}admin/fuel-brands/?id=${id}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return res;
  } catch (error) {
    console.error("Fuel brand delete error:", error);
    throw error;
  }
};

export {
  getFuelBrands,
  getFuelBrandById,
  createFuelBrand,
  updateFuelBrand,
  updateFuelBrandStatus,
  deleteFuelBrand,
};
